import React from 'react';
import { makeStyles } from 'tss-react/mui';

import BackgroundDesktop from 'ha/img-src/features/Background-Desktop.png';
import BackgroundDesktopWebp from 'ha/img-src/features/Background-Desktop.webp';
import BackgroundMobile from 'ha/img-src/features/Background-Mobile.png';
import BackgroundMobileWebp from 'ha/img-src/features/Background-Mobile.webp';

const useStyles = makeStyles()({
  picture: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});

export const AboveTheFoldPicture: React.FC = () => {
  const { classes } = useStyles();

  return (
    <picture className={classes.picture}>
      <source srcSet={BackgroundMobile} media="(max-width: 640px)" />
      <source
        srcSet={BackgroundMobileWebp}
        media="(max-width: 640px)"
        type="image/webp"
      />
      <source srcSet={BackgroundDesktopWebp} type="image/webp" />
      <img src={BackgroundDesktop} className={classes.image} alt="" />
    </picture>
  );
};
